export default class TextFull {
  constructor (element) {
    this.element = element
    window.element = this.element;
    window.addEventListener('resize', () => { this.reflow() }, true);
    window.addEventListener('load', () => { this.reflow() }, true);
    window.addEventListener('pageLoaded', () => {
      this.reflow()
    }, true);

    this.reflow()

    setTimeout(() => {
      this.reflow();
    }, 2000);
  }

  reflow () {
    const windowWidth = window.innerWidth - 100;
    const textWidth = this.element.clientWidth;
    const scale = Math.min(windowWidth / textWidth);
    $(this.element).css({
      'left': '60px',
      'position': 'absolute',
      'opacity': 1,
    });
    $(this.element).css('transform', 'scale('+scale+')');
  }

}



// WEBPACK FOOTER //
// ./scripts/util/textFull.js